import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UxService } from '~/app/core/services';
import { IApi, RoleService } from '../../core/services';
import { Role } from '../models';
import { DirectoryApi } from './directory.api';

@Injectable()
export class DirectoryRoleService extends DirectoryApi<Role> {

  searchAdmin: IApi<Role>;

  constructor(
    http: HttpClient,
    roleService: RoleService,
    uxService: UxService) {
    super('roles', http, roleService, uxService);
    this.searchAdmin = new DirectoryApi<Role>(`roles/searchAdmin`, http, roleService, uxService);
  }
}
